import { render, staticRenderFns } from "./InstituteJustice.vue?vue&type=template&id=33e4689c&scoped=true"
import script from "./InstituteJustice.vue?vue&type=script&lang=js"
export * from "./InstituteJustice.vue?vue&type=script&lang=js"
import style0 from "./InstituteJustice.vue?vue&type=style&index=0&id=33e4689c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e4689c",
  null
  
)

export default component.exports